import HmacSHA512 from 'crypto-js/hmac-sha512';
import encBase64 from 'crypto-js/enc-base64';

export const getEncryptionKey = (secret: string, key: string) => {
    const hmac = HmacSHA512(secret, key);
    return encBase64.stringify(hmac);
};
